var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaulLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 30,
    viewBox: "0 0 83 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_25",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 83,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 0H0V25.3435H83V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.624 0H0V24.6497H4.46173V16.3535H10.6386C15.3943 16.3535 18.6731 12.6299 18.6731 8.15744C18.6731 4.05179 15.5806 0 10.624 0ZM4.46933 12.232V4.11325H10.3921C12.5026 4.11325 14.212 6.13883 14.212 8.1264C14.212 10.2527 12.5032 12.232 10.3921 12.232H4.46933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6953 0V24.663H83.0074H82.9998V20.539H73.1596V0H68.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1496 8.58702L32.7294 17.0891H25.5762L29.1496 8.58702ZM28.765 0L17.5911 24.6624H22.2809L23.8009 21.2119H34.5604L36.0582 24.6624H40.7322L29.5507 0H28.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7374 0H57.2737V16.5785C57.2737 19.365 55.4116 21.2201 52.5985 21.2201C49.7854 21.2201 47.9258 19.365 47.9258 16.5785V0H43.4622V16.4391C43.4622 22.0862 46.9082 25.3435 52.6017 25.3435C58.2951 25.3435 61.738 22.0869 61.738 16.4391V0H61.7374Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaulLogoWhite);
export default __webpack_public_path__ + "static/media/PAUL_Logo_white.5e58a48255b396b2a62de8b69db9dd0f.svg";
export { ForwardRef as ReactComponent };